import { render } from "./NForm.vue?vue&type=template&id=6531824e&ts=true"
import script from "./NForm.vue?vue&type=script&lang=ts"
export * from "./NForm.vue?vue&type=script&lang=ts"

import "./NForm.vue?vue&type=style&index=0&id=6531824e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__